<template>
  
  
  <vx-card :title="brokerDataProp ? brokerDataProp.name : 'Add a new Broker'">
    <!-- <div>{{brokerData}}</div> -->
    <!-- <div>{{this.listingDataProp}}</div> -->


    <!-- <v-divider>General Details</v-divider> -->
    <div style="display:flex; align-items: center">
      <div class="mt-5 ml-2">
        <vs-avatar size="100px" :src="brokerData.form.image"/>
      </div>
      <div style="width:150px;">
        <div id="preview" class="text-center">
            <image-uploader
              :preview="false"
              :className="['fileinput', { 'fileinput--loaded': hasImage }]"
              capture="environment"
              :debug="2"
              :scaleRatio="1"
              :quality="1"
              :maxSize="1.5"
              accept=".jpg, .png, .jpeg"
              doNotResize="['gif', 'svg']"
              :autoRotate="true"
              outputFormat="file"
              @input="setImage"
              @onUpload="startImageResize"
              @onComplete="endImageResize"
            >
              <label for="fileInput" slot="upload-label">
                <figure>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    viewBox="0 0 32 32"
                  >
                    <path
                      class="path1"
                      d="M9.5 19c0 3.59 2.91 6.5 6.5 6.5s6.5-2.91 6.5-6.5-2.91-6.5-6.5-6.5-6.5 2.91-6.5 6.5zM30 8h-7c-0.5-2-1-4-3-4h-8c-2 0-2.5 2-3 4h-7c-1.1 0-2 0.9-2 2v18c0 1.1 0.9 2 2 2h28c1.1 0 2-0.9 2-2v-18c0-1.1-0.9-2-2-2zM16 27.875c-4.902 0-8.875-3.973-8.875-8.875s3.973-8.875 8.875-8.875c4.902 0 8.875 3.973 8.875 8.875s-3.973 8.875-8.875 8.875zM30 14h-4v-2h4v2z"
                    ></path>
                  </svg>
                </figure>
                <span class="upload-caption">{{
                    hasImage ? "Replace" : "Click to upload"
                  }}</span>
              </label>
            </image-uploader>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col md:w-1/3 w-full mt-5">
        <vs-input label="Name *" v-model="brokerData.form.name" class="w-full" />
      </div>
      <div class="vx-col md:w-1/3 w-full mt-5">
        <vs-input label="Email *"  v-model="brokerData.form.email" class="w-full" />
      </div>
      <div class="vx-col md:w-1/3 w-full mt-5">
        <vs-input label="Mobile Number"  v-model="brokerData.form.mobile" class="w-full" />
      </div>
    </div>
    <div class="vx-col w-full">
        <vs-input label="Address"  v-model="brokerData.form.address" class="w-full" />
    </div>
    <div class="vx-col w-full">
      <vs-textarea v-model="brokerData.form.description" label="Description" class="mb-0 md:mt-10 mt-6" rows="10" />
    </div>

    <div class="mt-5" style="display: flex; justify-content: flex-end;">
      <vs-button color="primary" type="filled" @click="saveBrokerData">Save</vs-button>
    </div>

  </vx-card>

</template>

<script>
  import {mapActions, mapGetters} from "vuex";
  import draggable from 'vuedraggable'
  import ImageUploader from 'vue-image-upload-resize'

    export default {
    name: "AddBrokerComponent",
    components: {
      draggable,
      ImageUploader
    },
    props: {
      brokerDataProp: {
        type: Object
      },
      isEdit: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        hasImage: false,
        backgroundLoading:'primary',
        colorLoading:'#fff',
        brokerData: {
          form: {
            name : null,
            email : null,
            image : null,
            imageFile: null,
            description : null,
            address : null,
            mobile : null
          },
          formData : new FormData(),
          url: 'admin/brokers',
          storeName: 'brokers',
          hasFormData: true,
        },
      }
    },
    async created() {
      
      this.setBrokerData()
    },
    computed: {
      ...mapGetters({
        isLoading: 'brokers/isLoading',
        error: 'brokers/error',
      })
    },
  watch: {

  },
    methods: {
      ...mapActions({
        add: 'add'
      }),
      setImage: function(output) {  
        console.log(output)   
        // console.log()
        console.log(URL.createObjectURL(output))
        this.hasImage = true;
        //this.imageGalleryData.imageFile = output
        //this.imageGalleryData.url = URL.createObjectURL(output);
        this.brokerData.form.imageFile = output;
        this.brokerData.form.image = URL.createObjectURL(output)
      },
      startImageResize() {
        this.$vs.loading({ text: 'Compressing Image Please Wait ...' })
      },
      //endImageResize(e) {
      endImageResize() {
        this.$vs.loading.close()
        this.successNotify('Done compressing image :)')
      },
      setBrokerData() {

        if (this.isEdit) {

          this.brokerData.form.name = this.brokerDataProp.name
          this.brokerData.form.email = this.brokerDataProp.email
          if(this.brokerDataProp.image){
            this.hasImage = true;
            this.brokerData.form.image = this.brokerDataProp.image
          }
          this.brokerData.form.description = this.brokerDataProp.description
          this.brokerData.form.address = this.brokerDataProp.address
          this.brokerData.form.mobile = this.brokerDataProp.mobile

          this.brokerData.url = `admin/brokers/${this.$route.params.brokerID}`
        }
      },

      
      async saveBrokerData() {

        const maxSize = Math.pow(1024,2)*4; //Max file is 4MB
        if(this.brokerData.form.imageFile && this.brokerData.form.imageFile.size > maxSize) {
          alert('Image size exceeds 4 MB, please try uploading a smaller image!');
          return ;
        }
        if(!this.brokerData.form.name){
          alert("Name of broker can't be empty!");
          return ;
        }
        if(!this.brokerData.form.email){
          alert("Email of broker can't be empty!");
          return ;
        }
        if (! /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.brokerData.form.email)){
            alert('Invalid Email...Please enter a correct email format')
            return ;
          }        
          
        Object.entries(this.brokerData.form).forEach(([key, value]) => {
          this.brokerData.formData.append(key, value);
        });
        this.$vs.loading({ text: 'Saving Broker Data' })
        this.add(this.brokerData).then((response) => {
          this.successNotify(response.data.message)
          console.log(response.data)
          this.$router.replace({
            name: 'Brokers'
          })
        }).catch((error) => {
          console.log(error);
          this.errorNotify(error)
        }).finally(() => {
          this.$vs.loading.close()
        })
      },
      errorNotify(msg){
        this.$vs.notify({color:'danger',title:'Error',text:msg})
      },
      successNotify(msg){
        this.$vs.notify({color:'success',title:'Success',text:msg})
      },
    },
  }
</script>

<style>
  #fileInput {
    visibility: hidden;
  }
</style>
